import React, {useState} from "react"
import puzzleAnswerData from "../puzzleAnswerData"

function KeyMatch(props) {
    const [keyOptions] = useState(5)
    const [correctKey] = useState(puzzleAnswerData[1].correctKey)
    const [currentImage, setCurrentImage] = useState({
        head: 0,
        middle: 1,
        bottom: 2
    })
    
    function handleClick() {
        const keyInput = currentImage.head.toString() + currentImage.middle.toString() + currentImage.bottom.toString()
        if (keyInput === correctKey) {
            triggerOverlay()
        } else {
            const errorMessage = document.getElementById("error")
            errorMessage.style.visibility = "visible"
            setTimeout(() => errorMessage.style.visibility = "hidden", 3000)
        }
    }
    
    function changeImageHead(event) {
        const {id} = event.target
        changeImage(id, currentImage.head, "head")
    }
    
    function changeImageMiddle(event) {
        const {id} = event.target
        changeImage(id, currentImage.middle, "middle")
    }
    
    function changeImageBottom(event) {
        const {id} = event.target
        changeImage(id, currentImage.bottom, "bottom")
    }
    
    function changeImage(id, image, section) {
        let imageUpdate
        if (id === "rightKeyArrow") {
            if (image < keyOptions) { 
                imageUpdate = image + 1
            } else {
                imageUpdate = 0
            }
        } else {
            if (image > 0) {
                imageUpdate = image - 1
            } else {
                imageUpdate = keyOptions
            }
        } 
        setCurrentImage({
            ...currentImage,
            [section]: imageUpdate
        })
    }
    
    function triggerOverlay() {
        const show = "on"
        const text = "Yes of course! That is what the key looks like. Unfortunately that key went missing just before the diamond."
        const trigger = "key"
        props.callBackOverlay(show, text, trigger)
        props.callBackPuzzleUpdate("keyMatch")
    }
    
    return (
        <div id="keyMatchPuzzle">
            <h3 id="keyIntro">Larry wants to investigate the diamond cabinet. Trouble is no one can remember what the key looks like to unlock it. Can you help?</h3>
            <div id="keyMatchControl">
                <div className="imageTextWrapper keyMatch">
                    <img className="placeholderImage locationImage" alt="suspect location" src={"./images/partOne/keys/heads/keyHead" + currentImage.head + ".png"} />
                    <div className="arrowButton" onClick={changeImageHead} id="leftKeyArrow"></div>
                    <div className="arrowButton" onClick={changeImageHead} id="rightKeyArrow"></div>  
                </div>
                <div className="imageTextWrapper keyMatch">
                    <img className="placeholderImage locationImage" alt="suspect location" src={"./images/partOne/keys/middles/keyMiddle" + currentImage.middle + ".png"} />
                    <div className="arrowButton" onClick={changeImageMiddle} id="leftKeyArrow"></div>
                    <div className="arrowButton" onClick={changeImageMiddle} id="rightKeyArrow"></div>  
                </div>
                <div className="imageTextWrapper keyMatch">
                    <img className="placeholderImage locationImage" alt="suspect location" src={"./images/partOne/keys/bottoms/keyBottom" + currentImage.bottom + ".png"} />
                    <div className="arrowButton" onClick={changeImageBottom} id="leftKeyArrow"></div>
                    <div className="arrowButton" onClick={changeImageBottom} id="rightKeyArrow"></div>  
                </div>
                <h3 id="error">That key doesn't seem to work. Try again.</h3>
                <button className="standardButton" onClick={handleClick}>That's The Key!</button>
            </div>
        </div>
    )
}

export default KeyMatch